import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Biens from "@/pages/Biens";
import Locataires from "@/pages/Locataires";
import Baux from "@/pages/Baux";
import Loyers from "@/pages/Loyers";
import Quittances from "@/pages/Quittances";
import Documents from "@/pages/Documents";
import Comptabilite from "@/pages/Comptabilite";
import Notifications from "@/pages/Notifications";
import Parametres from "@/pages/Parametres";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-zinc-500">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/biens" element={<Protected><Biens /></Protected>} />
          <Route path="/locataires" element={<Protected><Locataires /></Protected>} />
          <Route path="/baux" element={<Protected><Baux /></Protected>} />
          <Route path="/loyers" element={<Protected><Loyers /></Protected>} />
          <Route path="/quittances" element={<Protected><Quittances /></Protected>} />
          <Route path="/documents" element={<Protected><Documents /></Protected>} />
          <Route path="/comptabilite" element={<Protected><Comptabilite /></Protected>} />
          <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
          <Route path="/parametres" element={<Protected><Parametres /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
